import styled from 'styled-components/'

// Components
import Link from 'components/Link'

export const Wrapper = styled.div`
  padding-top: 32px;
  border-top: 1px solid ${({ theme }) => theme.colors.border[1]};
`

export const Title = styled.h2`
  margin-top: 0;
  margin-bottom: 0px;
  font-size: ${({ theme }) => theme.fontSizes.large};
  font-weight: ${({ theme }) => theme.fontWeights.bold};
  color: ${({ theme }) => theme.colors.foreground.secondary[1]};
`

export const Description = styled.p`
  margin-top: 8px;
  margin-bottom: 16px;
  font-size: ${({ theme }) => theme.fontSizes.small};
`

export const StyledLink = styled(Link)`
  white-space: break-spaces;
`
